import React from "react";
import { Typography, Grid, Paper, Slider, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import { change, formValueSelector } from "redux-form";
import ValidatedField from "../../Helpers/FieldValidator/ValidatedField";
import { renderRangeSlider } from "../../ReduxFormAdapters";

const rentMarks = [
    { value: 0, label: '0€' },
    { value: 5000, label: '5k€' },
    { value: 10000, label: '10k€' },
];

const sizeMarks = [
    { value: 0, label: '0m²' },
    { value: 500, label: '500m²' },
    { value: 1000, label: '1k m²' },
];

const dateMarks = [
    { value: 0, label: 'ASAP' },
    { value: 3, label: '3mo' },
    { value: 6, label: '6+mo' },
];

const convertSliderToDate = (value) => {
    const date = new Date();
    date.setMonth(date.getMonth() + value);
    return date;
};

const StickyFields = ({ dispatch, moveInDate, rentRange, sizeRange }) => {
    return (
        <div>
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <Typography variant="body2" color="secondary" gutterBottom>Move-in Date</Typography>
                    <div className="StickyFields-item" style={{ padding: '0 30px' }}>
                        <Slider
                            defaultValue={0}
                            min={0}
                            max={6}
                            step={1}
                            marks={dateMarks}
                            onChange={(e, value) => dispatch(change('signup', 'moveInDate', convertSliderToDate(value)))}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(v) => {
                                const found = dateMarks.find(m => m.value === v);
                                return found ? found.label : v;
                            }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" color="secondary" gutterBottom>Monthly Rent</Typography>
                    <div className="StickyFields-item" style={{ padding: '0 30px' }}>
                        <ValidatedField
                            name="rentRange"
                            component={renderRangeSlider}
                            defaultValue={[500, 5000]}
                            min={0}
                            max={10000}
                            step={100}
                            marks={rentMarks}
                            valueLabelDisplay="auto"
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" color="secondary" gutterBottom>Size (m²)</Typography>
                    <div className="StickyFields-item" style={{ padding: '0 30px' }}>
                        <ValidatedField
                            name="sizeRange"
                            component={renderRangeSlider}
                            defaultValue={[20, 200]}
                            min={0}
                            max={1000}
                            step={10}
                            marks={sizeMarks}
                            valueLabelDisplay="auto"
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

const selector = formValueSelector('signup');
export default connect(state => ({
    moveInDate: selector(state, 'moveInDate'),
    rentRange: selector(state, 'rentRange'),
    sizeRange: selector(state, 'sizeRange'),
}))(StickyFields);
